import React, { useEffect, useState } from "react";
import axios from "axios";

const WeatherJMA = () => {
  const [weather, setWeather] = useState(null);

  // 天気テキスト → 絵文字に変換
  const weatherToEmoji = (text) => {
    return text
      .replace(/晴れ/g, "☀")
      .replace(/くもり/g, "☁")
      .replace(/曇り/g, "☁")
      .replace(/雨/g, "☂")
      .replace(/雪/g, "❄")
      .replace(/雷/g, "⚡")
      .replace(/時々/g, "/")
      .replace(/のち|後/g, "→")
      .replace(/\s+/g, ""); // 空白除去
  };

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const res = await axios.get("https://www.jma.go.jp/bosai/forecast/data/forecast/270000.json"); // ← 大阪

        const data = res.data;

        // 地域名
        const areaName = data[0]?.timeSeries[0]?.areas[0]?.area?.name || "地域不明";

        // 天気
        const weathers = data[0]?.timeSeries[0]?.areas[0]?.weathers || [];

        // 降水確率（0〜3:今日, 4〜7:明日）
        const pops = data[0]?.timeSeries[1]?.areas[0]?.pops.map(p => (p === "" ? "0" : p)) || [];
        const todayPop = Math.max(...pops.slice(0, 4).map(v => Number(v)));
        const tomorrowPop = Math.max(...pops.slice(4, 8).map(v => Number(v)));

        // 今日の気温（速報）: [今日Min, 今日Max, 明日Min, 明日Max]
        const tempsToday = data[0]?.timeSeries[2]?.areas[0]?.temps || [];
        const todayTempMin = tempsToday[0] || "-";
        const todayTempMax = tempsToday[1] || "-";

        // 明日の気温（予報）
        const tempsMin = data[1]?.timeSeries[1]?.areas[0]?.tempsMin || [];
        const tempsMax = data[1]?.timeSeries[1]?.areas[0]?.tempsMax || [];
        const tomorrowTempMin = tempsMin[1] || "-";
        const tomorrowTempMax = tempsMax[1] || "-";

        setWeather({
          area: areaName,
          today: {
            weather: weathers[0] || "-",
            emoji: weatherToEmoji(weathers[0] || "-"),
            tempMin: todayTempMin,
            tempMax: todayTempMax,
            pop: todayPop,
          },
          tomorrow: {
            weather: weathers[1] || "-",
            emoji: weatherToEmoji(weathers[1] || "-"),
            tempMin: tomorrowTempMin,
            tempMax: tomorrowTempMax,
            pop: tomorrowPop,
          }
        });
      } catch (err) {
        console.error("天気データ取得エラー:", err);
      }
    };

    fetchWeather();
  }, []);

  if (!weather) return <div>読み込み中...</div>;

  return (
    <div>{weather.today.emoji}《{weather.today.pop}%》 【明日：{weather.tomorrow.emoji}】

    </div>
  );
};

export default WeatherJMA;
